import { render, staticRenderFns } from "./SampleDetails.vue?vue&type=template&id=245ce337&scoped=true"
import script from "./SampleDetails.vue?vue&type=script&lang=js"
export * from "./SampleDetails.vue?vue&type=script&lang=js"
import style0 from "./SampleDetails.vue?vue&type=style&index=0&id=245ce337&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ce337",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245ce337')) {
      api.createRecord('245ce337', component.options)
    } else {
      api.reload('245ce337', component.options)
    }
    module.hot.accept("./SampleDetails.vue?vue&type=template&id=245ce337&scoped=true", function () {
      api.rerender('245ce337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/service-satisfaction-questionnaire/SampleDetails.vue"
export default component.exports